import Banner from '../../components/v1/Banner';
import SliceCard from '../../components/v1/SliceCard';
import Goods from '../../components/v1/Goods';
import GoodsMore from '../../components/v1/GoodsMore';
import SectionCard from '../../components/v1/SectionCard';
import SectionGraphicText from '../../components/v1/SectionGraphicText';
import SectionCold from '../../components/v1/SectionCold';
import SectionPhone from '../../components/v1/SectionPhone';
import SectionVideo from '../../components/v1/SectionVideo';
import Partners from '../../components/v1/Partners';
import SectionList from '../../components/v1/SectionList';
import SectionBrackets from '../../components/v1/SectionBrackets';
import SectionGraphCompare from '../../components/v1/SectionGraphCompare';
import SectionCompare from '../../components/v1/SectionCompare';
import SectionListGraph from '../../components/v1/SectionListGraph';
import SectionSolarStation from '../../components/v1/SectionSolarStation';
import SectionSolar from '../../components/v1/SectionSolar';
import SectionMicroinverter from '../../components/v1/SectionMicroinverter';
import SectionCTA from '../../components/v1/SectionCTA';
import Footer from '../../components/FooterTcA';

export default function StatusItem() {
    return (
        <>
            <Banner />
            <SliceCard />
            <Goods />
            <SectionCard />
            <SectionSolarStation />
            <SectionMicroinverter />
            <SectionGraphicText />
            <SectionPhone />
            <Partners />
            <SectionCold />

            <SectionSolar />
            <SectionCompare />
            <SectionListGraph />
            <SectionGraphCompare />
            <SectionBrackets />
            <SectionList />
            <GoodsMore />
            <SectionVideo />
            <SectionCTA />
            <Footer />
        </>
    );
}
